import { render, staticRenderFns } from "./UserDashboardInfo.vue?vue&type=template&id=2b3b84ab&scoped=true&"
import script from "./UserDashboardInfo.vue?vue&type=script&lang=js&"
export * from "./UserDashboardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b84ab",
  null
  
)

export default component.exports